import NavigatorContainer from './navigator_container';

const Navigator = NavigatorContainer;

export default Navigator;
